import {NullableString} from "../../types/nullable-types";
import {IPassengerTypeSelectorsList} from "../passenger-types/passengers-types.service.interface";
import {WellKnownQueryParams} from "../window/window.service.interface";
import {PsoUserOptionsEnum} from "./flight-search-controller/pso.enums";

export class BookingEngineUrlBuilder {

    /**
     * o1 – mandatory. first origin. Value must be station IATA code.
     */
    origin1: string = "";

    /**
     * d1 – mandatory. first  destination. Value must be station IATA code.
     */
    destination1: string = "";

    /**
     * dd1 – mandatory. Departure date. Date format is yyyy-mm-dd
     */
    departureDate1: string = "";

    /**
     * dd2 – optional. Return date. Date format is yyyy-mm-dd
     */
    returnDate1: NullableString = null;

    /**
     * r – mandatory. roundtrip marker. True for round trip (dd2 becomes mandatory). False for one way.
     */
    isRoundTrip: boolean = true;

    /**
     * passengers types
     */
    passengersTypes: IPassengerTypeSelectorsList | null = null;

    /**
     * culture – optional. Sets IBE display language.
     */
    culture: string = "";


    /**
     * bc – optional. Booking currency. If not passed IBE will default to PSS rules.
     */
    bookingCurrency: string = "";


    /**
     * agentName – mandatory. Used for tracking purposes. When not set, deeplink will behave as a normal B2C sale.
     */
    agent: string = "";

    originalAgent: string = "";

    psoUserOption: PsoUserOptionsEnum = PsoUserOptionsEnum.None;

    buildUrl(origin: string): URL {

        const searchParams = new URLSearchParams();

        searchParams.append(WellKnownQueryParams.OriginStation, this.origin1);
        searchParams.append(WellKnownQueryParams.DestinationStation, this.destination1);
        searchParams.append(WellKnownQueryParams.DepartureDate, this.departureDate1);
        if(this.returnDate1) {
            searchParams.append(WellKnownQueryParams.ReturnDate, this.returnDate1);
        }

        if(this.psoUserOption !== PsoUserOptionsEnum.None) {
            searchParams.append(WellKnownQueryParams.PsoUserOption, this.psoUserOption.toString());
        }

        if(this.passengersTypes) {
            for(let passengerType of this.passengersTypes.getAll()) {
                if(passengerType.count > 0) {
                    searchParams.append(passengerType.getCurrentCodeForWebsiteSearch(), passengerType.count.toString());
                }
            }

        }

        searchParams.append(WellKnownQueryParams.IsRoundTripFlight, this.isRoundTrip.toString());
        searchParams.append(WellKnownQueryParams.BookingCurrency,this.bookingCurrency.toString());
        searchParams.append(WellKnownQueryParams.Culture, this.culture);
        if(this.agent) {
            searchParams.append(WellKnownQueryParams.Agent, this.agent);
        }

        if(this.originalAgent) {
            searchParams.append(WellKnownQueryParams.OriginalAgent, this.originalAgent);
        }

        const url = new URL(origin);
        url.search = searchParams.toString();

        return url;
    }

}
